import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SncPrivacyNoticeComponent } from './snc-privacy-notice.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    SncPrivacyNoticeComponent
  ],
  exports: [
    SncPrivacyNoticeComponent
  ]
})
export class SncPrivacyNoticeModule { }


// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-privacy-notice/snc-privacy-notice.module.ts